// extracted by mini-css-extract-plugin
module.exports = {"date":"table-row_date__3_omy"};